import {useContext} from 'react'
import {ConfirmationModal} from '../../../../components/ConfirmationModal'
import {ProductBadgesPageContext} from '../../context'

const DeleteProductBadgeModal = ({badge, onClose}: {badge: any; onClose: () => void}) => {
  const {deleteProductBadge, isOperationLoading, isLoading} = useContext(ProductBadgesPageContext)

  return (
    <ConfirmationModal
      show={true}
      onClose={onClose}
      onAction={() => deleteProductBadge(badge.id)}
      isOperationLoading={isOperationLoading}
      isDataLoading={isLoading}
      body={
        <>
          <p className='mb-2'>
            Do you really want to delete <strong>{badge.name}</strong> product badge?
          </p>
          <p>This action is irreversible and will remove all related product data.</p>
        </>
      }
    />
  )
}
export default DeleteProductBadgeModal
